import styled from "styled-components";

import { Box, FlexDiv } from "@/components/Atoms/Box";
import Typography from "@/foundation/Typography/V2";

export const CardLink = styled(Box)`
  cursor: pointer;
`;

export const RecipeItemContainer = styled(FlexDiv)`
  width: 100%;
  height: 240px;
  max-height: 240px;
  position: relative;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  background-size: cover;
  background-repeat: no-repeat, no-repeat;
  border: 1px solid #e4e7ec;
  border-radius: 16px;
  overflow: hidden;
`;

export const ImageWrapper = styled(FlexDiv)`
  position: relative;
  height: 100%;
  width: 100%;
  &:after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0) 30%,
      rgba(0, 0, 0, 0.6) 78.39%
    );
  }
`;

export const BottomTextContainer = styled(FlexDiv)`
  position: absolute;
  bottom: 24px;
  left: 24px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
export const CookingTimeAndIngredientsContainer = styled(FlexDiv)`
  gap: 8px;
  align-items: center;
`;

export const RecipeTitle = styled(Typography)`
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  display: flex;
  align-items: center;
  color: #ffffff;
`;

export const Chip = styled(FlexDiv)`
  padding: 4px 8px;
  gap: 8px;
  background: rgba(16, 24, 40, 0.6);
  border-radius: 24px;
  align-items: center;
`;

export const ChipText = styled(Typography)`
  font-style: normal;
  font-weight: 700;
  font-size: 10px;
  line-height: 16px;
  display: flex;
  align-items: center;
  color: #ffffff;
`;

export const TopContainer = styled(FlexDiv)`
  position: absolute;
  top: 24px;
  left: 24px;
  right: 24px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
